export const STORE_KINDS = ['fee_discount', 'spread_discount', 'cashback_boost', 'swap_free', 'streak_freeze', 'cash'];
/** Rewards that run for `hours` and pay back `pct` of something charged while they run. */
export const isTimedKind = (k) => k === 'fee_discount' || k === 'spread_discount' || k === 'cashback_boost';
export const STORE_KIND_LABEL = {
    fee_discount: 'Fee discount',
    spread_discount: 'Spread discount',
    cashback_boost: 'Cashback boost',
    swap_free: 'Swap-free night',
    streak_freeze: 'Streak freeze',
    cash: 'Cash',
};
/** Returns an error message, or null when the item is valid. */
export function validateStoreItem(i) {
    if (!STORE_KINDS.includes(i.kind))
        return 'Choose what the reward does';
    if (!i.name?.trim() || i.name.trim().length > 60)
        return 'Enter a name (up to 60 characters)';
    if ((i.description ?? '').length > 200)
        return 'Keep the description to 200 characters';
    if (!(Number.isInteger(i.price) && i.price >= 1 && i.price <= 100_000_000))
        return 'Price must be a whole number of points, 1 or more';
    if (i.stock !== null && !(Number.isInteger(i.stock) && i.stock >= 0))
        return 'Stock must be a whole number, or empty for unlimited';
    if (!(Number.isInteger(i.limitCount) && i.limitCount >= 1 && i.limitCount <= 1000))
        return 'Limit per client must be 1–1,000';
    if (!(Number.isInteger(i.limitDays) && i.limitDays >= 1 && i.limitDays <= 3650))
        return 'Limit period must be 1–3,650 days';
    if (!Array.isArray(i.excludedCountries) || i.excludedCountries.some((c) => !/^[A-Z]{2}$/.test(c)))
        return 'Countries must be 2-letter codes like GB';
    const p = i.params ?? {};
    if (isTimedKind(i.kind)) {
        if (!(typeof p.pct === 'number' && p.pct > 0 && p.pct <= 100))
            return 'Percentage must be above 0 and at most 100';
        if (!(Number.isInteger(p.hours) && p.hours >= 1 && p.hours <= 24 * 90))
            return 'Duration must be 1 hour to 90 days';
    }
    if (i.kind === 'cash' && !(typeof p.usd === 'number' && p.usd > 0 && p.usd <= 10_000))
        return 'Cash amount must be above $0 and at most $10,000';
    return null;
}
/** One line on what the reward does, for the store card. */
export function storeEffect(kind, p) {
    const dur = (h = 0) => (h % 24 === 0 ? `${h / 24} ${h === 24 ? 'day' : 'days'}` : `${h} ${h === 1 ? 'hour' : 'hours'}`);
    switch (kind) {
        case 'fee_discount':
            return `${p.pct}% of your live trading fees back for ${dur(p.hours)}`;
        case 'spread_discount':
            return `${p.pct}% of the spread on your live trades back for ${dur(p.hours)}`;
        case 'cashback_boost':
            return `+${p.pct}% cashback on your live trading fees for ${dur(p.hours)}`;
        case 'swap_free':
            return 'No overnight swap on your live positions for one night';
        case 'streak_freeze':
            return 'Keeps your mission streak if you miss a week';
        case 'cash':
            return `$${p.usd} added to your rewards to claim`;
    }
}
//# sourceMappingURL=store.js.map